import React, { useState, useEffect, createContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/form.css';
import CreateServiceCategory from "./create/createServiceCategory";
import UpdateServiceCategory from "./update/updateServiceCategory";
import axios from "axios";
import { API } from "../../../services/api";

axios.defaults.baseURL = API;

const ServiceCategoryContext = createContext();

function ServiceCategory() {

  const [dataList, setDataList] = useState([]);
  const [ServiceTypeList, setServiceTypeList] = useState([]);
  const [showData, setShowData] = useState([]);
  const [data, setData] = useState([]);

  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);

  const handleCloseUpdate = () => setShowUpdate(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const Search = event => {
    const { value } = event.target;
    if(value){
      var results = [];
      results = dataList.filter((data) => {
          return data.ServiceCategory.toLowerCase().includes(value.toLowerCase())
      });
      if (results) 
      setShowData(results);
      else 
      setShowData(dataList);
    } else 
    setShowData(dataList);
  }

  const openUpdate = (ServiceTypeID, ServiceType, ServiceCategoryID, ServiceCategory) => {
    var list = [];
    list.push({
      ServiceTypeID: ServiceTypeID,
      ServiceType: ServiceType,
      ServiceCategoryID: ServiceCategoryID,
      ServiceCategory: ServiceCategory
    });
    setData(list);
    setShowUpdate(true);
  };

  async function getAllServiceCategory() {
    axios
      .get("/getAllServiceCategory")
      .then((response) => {
        let Data = response?.data;
        setDataList(Data);
        setShowData(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getAllServiceType() {
    axios
      .get("/getAllServiceType")
      .then((response) => {
        let Data = response?.data;
        setServiceTypeList(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  
  useEffect(() => {
    getAllServiceCategory();
    getAllServiceType();
  }, []);

  return (
    <ServiceCategoryContext.Provider value={{dataList, setDataList, ServiceTypeList, data, setShowData}}>
      <div className="formContent">
        <CreateServiceCategory show={show} onClick={handleClose}/>
        <UpdateServiceCategory show={showUpdate} onClick={handleCloseUpdate}/>
        <div className="Header">
          <div className="title">
              <span>ຂໍ້ມູນ ໝວດນວດ</span>
          </div>
          <div className="txtSearch">
            <input placeholder="ຄົ້ນຫາ" onChange={(e) => Search(e)} />
            <button className="btn btn-primary" onClick={handleShow} >ເພີ່ມ</button>
          </div>
        </div>
        <div className="Body">
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th>ລ/ດ</th>
                <th>ປະເພດນວດ</th>
                <th>ໝວດນວດ</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                showData && showData.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td >{y + 1}</td>
                        <td >{x.ServiceType}</td>
                        <td >{x.ServiceCategory}</td>
                        <td >
                          <button className="btn btn-secondary" value={x.ServiceCategoryID} type="button" onClick={() => openUpdate(x.ServiceTypeID, x.ServiceType, x.ServiceCategoryID, x.ServiceCategory)}>ແກ້ໄຂ</button>
                        </td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </ServiceCategoryContext.Provider>
  );
};

export {ServiceCategoryContext};
export default ServiceCategory;
